import { apiClient } from '../api/client';

export interface PlayersOnline {
  total: number;
  servers: { name: string; count: number; max: number | null; players: { nick: string; since: string }[] }[];
}

export interface PlayTimeRanking {
  period: 'month' | 'all';
  players: { nick: string; seconds: number }[];
}

/** Página Jogadores: quem está jogando agora e o tempo de jogo (contados pelo plugin). */
export const playersOnlineService = {
  async online(storeId: string): Promise<PlayersOnline> {
    return apiClient.get<PlayersOnline>(`/public/stores/${storeId}/players-online`);
  },
  async ranking(storeId: string, period: 'month' | 'all', limit = 10): Promise<PlayTimeRanking> {
    return apiClient.get<PlayTimeRanking>(`/public/stores/${storeId}/play-time/top?period=${period}&limit=${limit}`);
  },
};

/** "125h 30min", "3h 05min", "12min". */
export function tempoDeJogo(segundos: number): string {
  const h = Math.floor(segundos / 3600);
  const m = Math.floor((segundos % 3600) / 60);
  if (h > 0) return `${h}h ${String(m).padStart(2, '0')}min`;
  return `${Math.max(m, segundos > 0 ? 1 : 0)}min`;
}

/** A loja mostra a página Jogadores? (loja de jogo e o lojista não desligou). */
export const temPaginaDeJogadores = (store?: { gameType?: string | null; showOnlinePlayers?: boolean } | null): boolean =>
  !!store && store.gameType !== 'DIGITAL' && (store.showOnlinePlayers ?? true);
